import Vue from "vue";
// import iView from "view-design";
import axios from "axios";
// import ProIview from "pro_iview";
import "pro_iview/lib/pro-iview.css";
import "view-design/dist/styles/iview.css";
import "@/Ali-icon/iconfont.css";
import VueClipboard from "vue-clipboard2";
import VCalendar from "v-calendar";
import { initServerConfig } from "@/service/server";
import "@/assets/css/common.less";
import "@/assets/css/table-title.less";
import vClickOutside from "v-click-outside";

// 先调用服务器 server.json 接口，再初始化依赖运行时配置的 i18n、router 和 http。
async function bootstrap() {
  await initServerConfig();
  // server.json 加载完成后再执行 i18n 模块，确保模块初始化阶段也能读取运行时环境配置。
  const {
    default: I18n
  } = await import("../lang/index");
  // gc-i18n 必须早于会调用 $t 的业务模块加载。
  Vue.use(I18n);
  const [{
    default: App
  }, {
    default: router
  }, {
    default: store
  }, {
    default: config
  }, {
    default: http
  }, {
    closeRouteViewDesignOverlays,
    stopEventDrawer
  }] = await Promise.all([import("./App.vue"), import("./router"), import("./store"), import("./config"), import("./libs/http"),
  // util.js 含有构建后生成的 $t 调用，必须在 i18n 安装后再加载。
  import("./utils/util.js")]);
  // 使用 gc-i18n 中的页面标题翻译；语言包切换完成后立即同步浏览器标签名。
  const updateDocumentTitle = event => {
    const language = event && event.detail && event.detail.language;
    // 非中文语言包尚未提供标题时使用中性品牌名，避免刷新阶段短暂回退中文。
    const fallbackTitle = language === "zh-CN" ? config.title : "iWork";
    document.title = typeof window.$t === "function" ? window.$t("pvgizmb", fallbackTitle) : fallbackTitle;
  };
  window.addEventListener("gc-i18n-language-changed", updateDocumentTitle);
  // 先配置 Axios，再交给 ProIview；ProIview 会把该参数作为可调用的 Axios 实例使用。
  http(axios);
  // 补充 router/http 配置；i18n 已在业务模块加载前安装，避免模块调用未定义的 $t。
  I18n.install(Vue, router, axios);
  Vue.use(VueClipboard);
  Vue.use(vClickOutside);
  Vue.use(VCalendar);
  stopEventDrawer(Vue);
  Vue.prototype.$config = config;
  Vue.config.productionTip = false;
  // 事件总线
  Vue.prototype.$bus = new Vue();
  function initMaterialSymbolsReady() {
    const readyClass = "material-symbols-ready";
    const fontFamily = "'Material Symbols Outlined'";
    const root = document.documentElement;

    // Material Symbols 使用 ligature 文本，等待字体可用后再显示，避免刷新首屏闪现 search/star 等文本。
    if (document.fonts && document.fonts.load) {
      document.fonts.load(`24px ${fontFamily}`).then(() => {
        root.classList.add(readyClass);
      }).catch(() => {
        // 字体加载失败时保留占位隐藏，避免把 ligature 文本暴露给用户。
      });
      return;
    }

    // 旧浏览器没有 Font Loading API，维持原有展示能力，避免图标永久隐藏。
    root.classList.add(readyClass);
  }
  initMaterialSymbolsReady();
  // 全局混入，关闭tab时清除组件缓存
  Vue.mixin({
    beforeRouteLeave(to, from, next) {
      // 浏览器返回或菜单切页前，先关闭当前页面里已打开的 Modal / Drawer，
      // 避免 keep-alive 页面退场后 transfer 浮层遗留到下一页。
      closeRouteViewDesignOverlays(this);
      if (this.$vnode.parent && this.$vnode.parent.componentInstance.cache) {
        let key = this.$vnode.componentOptions.Ctor.cid; // 当前关闭的组件名
        let cache = this.$vnode.parent.componentInstance.cache; // 缓存的组件
        let keys = this.$vnode.parent.componentInstance.keys; // 缓存的组件名
        if (cache[key] != null) {
          delete cache[key];
          let index = keys.indexOf(key);
          if (index > -1) {
            keys.splice(index, 1);
          }
        }
      }
      next();
    }
  });
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount("#app");
}
bootstrap();